/* eslint-disable no-console */
import React, { useEffect, useState } from 'react';
import classnames from 'classnames';
import { isEmpty, map, noop } from 'lodash/fp';
import IconCaret from '../../files/caret.svg';

const DESKTOP_MEDIA_QUERY = '(min-width: 1330px)';

const mapWithIndex = map.convert({ cap: false });

const TabNav = ({
  parentPageLabel = 'Overview',
  dropdownLabel = 'Jump to',
  links,
}) => {
  const initialIsExpanded = true;

  const [isExpanded, setIsExpanded] = useState(initialIsExpanded);

  useEffect(() => {
    if (typeof window !== 'object') {
      return noop;
    }

    function handleTabNavResize() {
      const mediaQuery = window.matchMedia(DESKTOP_MEDIA_QUERY);
      setIsExpanded(mediaQuery.matches);
    }

    window.addEventListener('resize', handleTabNavResize);
    return () => window.removeEventListener('resize', handleTabNavResize);
  }, []); // Empty array ensures that effect is only run on mount and unmount

  const buttonClasses = classnames(`tab-nav__btn`, { active: isExpanded });

  const listClasses = classnames(`tab-nav__list margins-off`, {
    active: isExpanded,
  });

  const Tab = ({ title, url, active }, index) => {
    const linkClasses = classnames('tab-nav__link', { active });
    return (
      <li key={url} className="tab-nav__item">
        <a href={url} className={linkClasses}>
          {index === 0 ? parentPageLabel : title}
        </a>
      </li>
    );
  };

  return isEmpty(links) ? null : (
    <nav className="tab-nav">
      <button
        className={buttonClasses}
        onClick={() => setIsExpanded(!isExpanded)}
        aria-expanded={isExpanded}
        aria-label={isExpanded ? 'Collapse' : 'Expand'}
        aria-controls="tab-nav__list"
      >
        <span className="tab-nav__label">{dropdownLabel}</span>
        <IconCaret focusable={false} className="tab-nav__icon" />
      </button>
      <ul className={listClasses} id="tab-nav__list">
        {mapWithIndex(Tab, links)}
      </ul>
    </nav>
  );
};

export default TabNav;
